var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"chevronDown"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"chevronDown","fill":"#000000"},React.createElement("polygon",{"id":"Page-1","transform":"translate(9.207030, 8.707050) rotate(90.000000) translate(-9.207030, -8.707050) ","points":"7.414 3.0001 6 4.4141 10.293 8.7071 6 13.0001 7.414 14.4141 12.414 9.4131 12.414 7.9991"})))]);
}

ChevronDown.defaultProps = {"width":"18px","height":"18px","viewBox":"0 0 18 18","version":"1.1"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;



// WEBPACK FOOTER //
// ./src/icons/chevronDown.svg